import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ErpOrder } from '../../models/orderline'
import { AddCartEvent, CartProduct } from '../../../cart/models/cart-models'
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { LIST_VIEW } from '../../../core/helpers/theme-config';

@Component({
  selector: 'app-order-page',
  templateUrl: './order-page.component.html',
  styleUrls: ['./order-page.component.scss']
})
export class OrderPageComponent {
  @Input() loading: boolean
  @Input() expanding: boolean
  @Input() orders: ErpOrder[]
  @Input() cartProducts: {[_id:string]: CartProduct}
  @Input() currency: string

  @Output() onExpand = new EventEmitter<void>()
  @Output() onAddCart = new EventEmitter<AddCartEvent>()

  fullWidthView$: Observable<boolean>
  viewType = LIST_VIEW

  constructor(private store: Store<any>) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
  }

  get hasOrders(): boolean {
    return this.orders && !!this.orders.length
  }

  expand() {
    this.onExpand.emit()
  }

  addCart(event: AddCartEvent) {
    this.onAddCart.emit(event)
  }
}
